<template>
  <div :id="id">
    <input v-if="search" v-model="pesquisa" placeholder="Pesquise..."
      style="width: 100%; margin-bottom: 0.5em">
    <section :style="gridStyle">
      <div v-for="(item, index) in listaNormalizada"
        :key="`${index}-${item.group}-${item.label}`"
        :class="{ secao: !('name' in item) }"
        v-show="!item.permaHidden && !item.hidden"
        :draggable="draggable && 'name' in item" @dragstart="dragStart(index)"
        @dragover.prevent="dragOver(index)" @drop="drop(index)">
        <label>
          <input v-if="'name' in item" v-model="item.value" type="checkbox">
          {{ item.label }}
        </label>
      </div>
    </section>
  </div>
</template>

<style scoped>
.secao {
  grid-column: 1 / -1;
  font-weight: bold;
  margin-top: 4px;
}
</style>

<script>
/**
 * @description Versão Vue do `Siggma.utils.camposSelecionaveis`
 * @props {Array} value - Retorna o `name` de todos os campos selecionados
 * @props {Array} lista - Lista de campos nesse formato:
 *
 * `{ label: string, name?: string, value: boolean = false, group?: number = 1, hidden: boolean = false }`
 *
 * Campos sem `name` são tratados como títulos de um grupo, ocupando uma linha inteira
 */
export default {
  name: "s-campos-selecionaveis",

  inject: ["hdl"],

  props: {
    id: {
      type: String,
      default: `uuid${Math.uuid(8)}`,
    },
    value: Array,
    lista: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Number,
      default: 1,
    },
    sort: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pesquisa: "",
      listaNormalizada: [],
      draggingIndex: null,
      hoverIndex: null,
    };
  },

  computed: {
    gridStyle() {
      return {
        display: "grid",
        gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
      };
    },
  },

  watch: {
    // carregar valores de preferências
    value(novo) {
      const lista = this.listaNormalizada.filter((o) => o.value).map((o) =>
        o.name
      );
      if (lista.toString() !== novo.toString()) {
        this.listaNormalizada.map((o) => o.value = novo.includes(o.name));
      }
    },
    lista: {
      handler() {
        this.updateLista();
      },
      deep: true,
    },
    listaNormalizada: {
      handler(novo) {
        const lista = novo.filter((o) => o.value).map((o) => o.name);
        this.$emit("input", lista);
      },
      deep: true,
    },
    pesquisa(novo) {
      const pesquisa = novo?.toLowerCase() ?? "";
      for (const item of this.listaNormalizada) {
        if (!novo || !Object.hasOwn(item, "name")) {
          item.hidden = false;
          continue;
        }
        const label = item.label.toLowerCase();
        item.hidden = !label.includes(pesquisa);
      }
    },
  },

  methods: {
    updateLista() {
      const lista = [...this.lista].map((o) => {
        return {
          ...o,
          value: o.value ?? false,
          group: o.group ?? 1,
          permaHidden: o.hidden ?? false,
        };
      });
      this.listaNormalizada = this.sort
        ? lista.sort((a, b) => {
          if (a.group < b.group) {
            return -1;
          } else if (a.group > b.group) {
            return 1;
          }
          if (!Object.hasOwn(b, "name")) {
            return 1;
          } else if (!Object.hasOwn(a, "name")) {
            return -1;
          }
          return a.label.localeCompare(b.label);
        })
        : lista;
    },
    dragStart(index) {
      this.draggingIndex = index;
      this.hoverIndex = null;
    },
    dragOver(index) {
      this.hoverIndex = index;
    },
    drop(index) {
      if (this.draggingIndex === null || this.draggingIndex === index) {
        this.draggingIndex = null;
        this.hoverIndex = null;
        return;
      }

      const movedItem = this.listaNormalizada.splice(this.draggingIndex, 1)[0];
      this.listaNormalizada.splice(index, 0, movedItem);

      this.draggingIndex = null;
      this.hoverIndex = null;
      this.$emit("change", this.listaNormalizada);
    },
  },

  beforeDestroy() {
    jQuery(this.$el).off();
  },

  mounted() {
    this.updateLista();
  },
};
</script>